module.exports = __webpack_public_path__ + "img/ai-calculating-tomorrow@3x.8e002fe5.png";